import React from "react";
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { relationsSearchActions } from '../../../store/relationsSearchStore';
import { connect } from 'react-redux';
import RelationsSearchSearch from './relationsSearchSearch';
import RelationsSearchSearchResults from "./relationsSearchSearchResults";

const searchIntanceActions = {
    submit: "submit",
    check: "check",
    back: "back",
    hasResults: "hasResults"
}

export const checkTypes = {
    single: "radio",
    any: "check"
}

class RelationsSearchInstance extends React.Component {
    state = {
        searchInstance: {
            key: this.props.instanceKey,
            ordinal: this.props.ordinal,
            query: undefined,
            qsEntityId: undefined
        }
    }

    onAction(action, value) {
        switch (action) {
            case searchIntanceActions.submit:
                this.props.setEntityId(this.state.searchInstance.key, value.entityId);
                this.setState({ searchInstance: { ...this.state.searchInstance, query: value.query, qsEntityId: value.entityId } });
                break;
            case searchIntanceActions.check:
                if (typeof (this.props.onEntityCheck) === 'function') {
                    if (value.length > 0) {
                        this.props.setEntityId(this.state.searchInstance.key, value[0]);
                        this.props.onEntityCheck(value);
                    }
                }
                break;
            case searchIntanceActions.back:
                this.setState({ searchInstance: { ...this.state.searchInstance, query: undefined } });
                break;
            case searchIntanceActions.hasResults:
                if (typeof (this.props.onHasResults) === 'function') {
                    this.props.onHasResults(value);
                }
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <>
                <RelationsSearchSearch searchInstance={this.state.searchInstance} onAction={(a, v) => this.onAction(a, v)} renderTypeTabs={this.props.renderTypeTabs} marketAttribute={this.props.marketAttribute} showSearchButton={this.props.showSearchButton} disableSubjectLabel={this.props.disableSubjectLabel} />
                <RelationsSearchSearchResults searchInstance={this.state.searchInstance} onAction={(a, v) => this.onAction(a, v)} checkType={this.props.checkType} scroller={this.props.scroller} />
            </>
        )
    }
}


export default withRouter(withLocalize(connect(
    state => { return { ...state.relationsSearch, user: state.userContext } },
    dispatch => bindActionCreators(Object.assign({}, relationsSearchActions), dispatch),
)(RelationsSearchInstance)));


